var map = {
	"./Downtime/Crafting.html": "eb4d",
	"./Downtime/Downtime Activities.html": "e620",
	"./Downtime/Downtime.html": "f49a",
	"./Downtime/Entanglements.html": "0f83",
	"./Downtime/Heat.html": "6706",
	"./Downtime/Magnitude.html": "744d",
	"./Downtime/Payoff.html": "5fc3",
	"./Downtime/Rituals.html": "3504",
	"./Downtime/Vice.html": "53c2",
	"./README.html": "eb16",
	"./The Basics/Action Roll.html": "cc9f",
	"./The Basics/Actions & Attributes.html": "756b",
	"./The Basics/Advancement.html": "968d",
	"./The Basics/Coin & Stash.html": "6f03",
	"./The Basics/Consequences & Harm.html": "51ca",
	"./The Basics/Effect.html": "564b",
	"./The Basics/Fortune Roll.html": "3c36",
	"./The Basics/Gathering Information.html": "17b1",
	"./The Basics/Progress clocks.html": "ef2e",
	"./The Basics/Resistance & Armor.html": "0365",
	"./The Basics/Setting Position & Effect.html": "45ff",
	"./The Basics/Stress & Trauma.html": "7077",
	"./The Basics/The Basics.html": "7faa",
	"./The Basics/The Core System.html": "b03c",
	"./The Basics/The Faction Game.html": "3e1b",
	"./The Characters/Character Creation.html": "f021",
	"./The Characters/Character playbook.html": "3c7c",
	"./The Crew/Crew Creation.html": "55f6",
	"./The Crew/Crew Playbook.html": "abe6",
	"./The Score/Planning & Engagement.html": "35c8",
	"./The Score/Teamwork.html": "1d79",
	"./The Score/The Score.html": "6074"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d9d";